import React from 'react'
import Sliderabout from '../inc/Sliderabout'

function About() {
  return (
    <div>
      <br />

      <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-8 mt-3">

              <div className="card-body">
                <h1 style={{color:"#EB1C22"}} className="card-title mb-2">About us</h1>
                <p className="card-text justify">At <b style={{color:"#D4B10D"}}>The Love Bird's Icecream Parlour</b>, we believe that ice cream is more than just a treat—it's an experience. Nestled in the heart of Krishnagar, our cozy and charming parlour is the perfect spot to enjoy handcrafted ice creams made with love, premium ingredients, and a sprinkle of joy.
                </p>
                <p className='justify'>From timeless classics like creamy vanilla and rich chocolate to adventurous flavors inspired by local and global delights, every scoop tells a story of flavor, freshness, and passion. Whether you're sharing a sundae with someone special or savoring a cone on a sunny day, we’re here to make every visit a moment to remember.</p>
                <p className='justify mb-4'>Our journey began with a simple idea: celebrating love, laughter, and the little things in life. Just like the lovebirds that symbolize connection and happiness, we aim to bring people together through the joy of great ice cream.</p>

                <h6 className='justify'>Come visit The Love Bird's Icecream Parlour—where every scoop is served with a smile, and every moment feels sweeter.</h6>
              </div>
            </div>
            <div className="col-md-4 mt-3">
            <Sliderabout/>
            </div>
          </div>
        </div>

      </div>
      <br />
    </div>
  )
}

export default About